import React, { useEffect, useState } from 'react';
import '../css/forms.css'
import { SubmitButton } from '../components/Buttons';

const PatientsForm = ( { data, formTitle } ) => {

    const [inputName, setInputName] = useState(null);
    const [inputDocType, setInputDocType] = useState(null);
    const [inputDocNumber, setInputDocNumber] = useState(null);
    const [inputCountry, setInputCountry] = useState(null);
    const [inputEmail, setInputEmail] = useState(null);
    const [inputTel, setInputTel] = useState(null);
    const [inputHealth, setInputHealth] = useState(null);
    const [inputAddress, setInputAddress] = useState(null);

    useEffect(() => {
        if (data !== null){
            setInputName(data["Nombre del paciente"]);
            setInputDocType(data["Tipo de Documento"]);
            setInputDocNumber(data["Número de identificación"]);
            setInputCountry(data["País"]);
            setInputEmail(data["Correo electrónico"]);
            setInputTel(data["Teléfono"]);
            setInputHealth(data["Entidad aseguradora de salud"]);
            setInputAddress(data["Dirección"]);
        } 
    },[])
    
    return (
        <form action="" className='generic-form'>
            <h1>{formTitle} Paciente</h1>

            <div className='input-wrapper'>
                <label htmlFor="name" className='input-lbl'>Nombre</label>
                <input 
                    type="text" 
                    id='name' 
                    className='generic-input'
                    value={ inputName }
                    onChange={(e) => setInputName(e.target.value)}
                />
            </div>

            <div className='input-container'>
                <div className='input-wrapper'>
                    <label htmlFor="id-type" className='input-lbl'>Tipo de documento</label>
                    <select name="id-type" id="id-type" className='generic-input'>
                        <option value="">Seleccionar</option>
                        {inputDocType && <option value={inputDocType} selected>{inputDocType}</option>}
                    </select>
                </div>  

                <div className='input-wrapper'>
                    <label htmlFor="id-number" className='input-lbl'>Número de identificación</label>
                    <input 
                        type="number" 
                        id='id-number' 
                        className='generic-input'
                        value={ inputDocNumber }
                        onChange={(e) => setInputDocNumber(e.target.value)}
                        />
                </div>
            </div>

            <div className='input-container'>
                <div className='input-wrapper'>
                    <label htmlFor="country" className='input-lbl'>País</label>
                    <select name="country" id="country" className='generic-input'>
                        {inputCountry && <option value={inputCountry} selected>{inputCountry}</option>} 
                        <option value="">Option 1</option>
                        <option value="">Option 2</option>
                    </select>
                </div>
                
                <div className='input-wrapper'>
                    <label htmlFor="tel-number" className='input-lbl'>Teléfono</label>
                    <input 
                        type="number" 
                        id='tel-number' 
                        className='generic-input' 
                        value={ inputTel }
                        onChange={(e) => setInputTel(e.target.value)}
                    />
                </div>
            </div>
            
            <div className='input-wrapper'>
                <label htmlFor="email" className='input-lbl'>Correo electrónico</label>
                <input 
                    type="email" 
                    id='email' 
                    className='generic-input'
                    value={ inputEmail }
                    onChange={(e) => setInputEmail(e.target.value)}
                />
            </div>
            
            <div className='input-wrapper'>
                <label htmlFor="health-entity" className='input-lbl'>Entidad aseguradora de salud</label>
                <select name="heanth-entity" id="health-entity" className='generic-input'>
                    <option value="">Option</option>
                    {inputHealth && <option value={inputHealth} selected>{inputHealth}</option>} 
                </select>
            </div>

            <div className='input-wrapper'>
                <label htmlFor="address" className='input-lbl'>Dirección</label>
                <input 
                    type="text" 
                    id='address'
                    className='generic-input'
                    value={ inputAddress }
                    onChange={(e) => setInputAddress(e.target.value)}
                />
            </div>
            
            <div className='btn-container'>
                <div className='btn-wrapper'>
                    <SubmitButton text='Guardar'/>
                </div>
            </div>
        </form>
    );
}

export default PatientsForm;
